/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Petty_Wise_Penguin_WorkInputs */

const fr_petty_wise_penguin_work = /** @type {(inputs: Petty_Wise_Penguin_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune description`)
};

/**

* @param {Petty_Wise_Penguin_WorkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const petty_wise_penguin_work = /** @type {((inputs?: Petty_Wise_Penguin_WorkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Petty_Wise_Penguin_WorkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_petty_wise_penguin_work(inputs)
});